const siteData = {
    logo: require('../assets/images/logo.png'),
    logoWithText: require('../assets/images/logo.png'),
    logoText: "Nexus paper packs",
    logoContra: require('../assets/images/white logo.png'),
    name: "",
    slogan: "Nexus Eco-Friendly Paper Cups are crafted from sustainably sourced materials and lined with biodegradable coatings, ensuring minimal environmental impact.",
    mobile: [
        {
            label: "+91 99791 45600",
            value: "919979145600"
        },
        {
            label: "+44 7747 248693",
            value: "44747248693"
        }
    ],
    email: "info@nexuspaperpacks.com"
}
export {
    siteData
}